import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class AddressReward extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default AddressReward
